import { useQuery } from "@tanstack/react-query";

import { useAuth } from "contexts/AuthContext";
import { BIM } from "utils/bim";

type GetBIMsResponseData = {
  data: BIM[];
  errors: any[];
}

export const useGetProjectBIMsQuery = (
  projectId: string,
  workspace?: string
) => {
  const { authApi } = useAuth();

  const result = useQuery({
    queryKey: workspace
      ? ["bims", projectId, workspace]
      : ["bims", projectId],
    queryFn: async () => {
      if (projectId === "") return [];
      const path = workspace
        ? `/project/${projectId}/bims/?workspace=${workspace}`
        : `/project/${projectId}/bims`;

      const { data: responseBody } = await authApi.get<GetBIMsResponseData>(path);
      return responseBody.data;
    },
  });

  return result;
};
